import { CODE_2FA_MIN_LENGTH, PASSWORD_MIN_CHAR } from ".";

export const EMAIL_REQUIRED = "Email address is required.";
export const INVALID_EMAIL = "Invalid email address";
export const REQUIRED = "Required";
export const PASSWORD_VALIDATION =
  "Password must be at least 10 characters with special, uppercase, lowercase, and numeric characters.";
export const PASSWORD_REQUIRED = "Password is required";
export const PASSWORD_MUST_MATCH =
  "Confirm Password must match with the password";
export const MIN_CHAR_LENGTH = `Please enter min ${PASSWORD_MIN_CHAR} char`;
export const PASSWORD_SPECIAL_CHAR_REQUIRED =
  "Password must contain at least one special character.";
export const CODE_REQUIRED_2FA = "2fa code is required";
export const ROLE_IS_REQUIRED = "Role is required";

export const INVALID_PHONE = "This is not a valid number.";
export const PHONE_REQUIRED = "Phone number is required.";

export const FIRST_NAME_REQUIRED = "First name is required.";
export const LAST_NAME_REQUIRED = "Last name is required.";

export const CONFIRM_PASSWORD_REQUIRED = "Confirm password is required";

export const CODE_2FA_MIN_LENGTH_MSG = `Please enter exact ${CODE_2FA_MIN_LENGTH} digits`;

export const CODE_2FA_DIGIT_ONLY_MSG = `Code must be digits only`;

export const IMAGE_FILE_TYPES =
  "Please select a valid image (png, jpg, or jpeg).";
export const IMAGE_FILE_SIZE_LIMIT = "Image size exceeds 1MB limit.";

export const QUESTION_REQUIRED = "Question is required.";
export const ANSWER_REQUIRED = "Answer is required.";

export const QUERY_REQUIRED = "Query is required.";
export const SUBJECT_REQUIRED = "Subject is required.";
export const DESCRIPTION_REQUIRED = "Description is required.";

export const DEPARTMENT_NAME_REQUIRED = "Department name is required.";
export const DEPARTMENT_NAME_MAX_LENGTH =
  "Department name must be at most 50 characters.";
export const DEPARTMENT_REQUIRED = "Department is required.";

export const DEPARTMENT_MANAGER_REQUIRED = "Department manager is required.";
export const COUNTRY_REQUIRED = "Country is required.";
export const PROVINCE_REQUIRED = "Province is required.";
export const CITY_REQUIRED = "City is required.";
export const ZIPCODE_REQUIRED = "Zipcode is required.";
export const INVALID_ZIPCODE =
  "Invalid Zipcode, please provide a valid zipcode.";
export const STORE_NAME_REQUIRED = "Store name is required.";
export const STORE_NAME_MAX_LENGTH =
  "Store name must be at most 50 characters.";
export const STORE_ADMIN_REQUIRED = "Store admin is required.";
export const ADDRESS_REQUIRED = "Address is required.";
export const NAME_REQUIRED = "Name is required.";
export const NAME_MAX_LENGTH = "Name must be at most 70 characters.";
export const STORE_REQUIRED = "Store is required.";

export const CHANNEL_NAME_REQUIRED = "Channel Name is required.";
export const CHANNEL_NAME_MAX_LENGTH =
  "Channel Name must be at most 50 characters..";

export const CONTENT_REQUIRED = "Content is required.";
export const PRIORITY_REQUIRED = "Priority is required.";
export const CHANNEL_REQUIRED = "Channel is required.";
export const ALERTED_MEMBERS_REQUIRED = "Alerted members is required.";
export const ALERT_IMAGE_REQUIRED = "Alert image is required.";

// CMS
export const CMS_PAGE_NAME_REQUIRED = "Page name is required.";
export const CMS_DESCRIPTION_REQUIRED = "Description is required.";
